// @flow
import * as React from 'react';
import Flex from 'components/Flex';
import Box from 'components/Box';
import { COUNTRIES, US_STATES } from 'utils/constants';
import { InputField, SelectField } from 'components/Form';

const AddressWithoutLocationForm = ({
  namePrefix,
  useUSStateDropdown
}: {
  namePrefix?: string,
  useUSStateDropdown?: boolean
}) => {
  const getName = name => (namePrefix ? `${namePrefix}.${name}` : name);

  return (
    <>
      <SelectField
        name={getName('country')}
        label={
          /* TRANSLATORS: Form field for address country */
          `${getText('Country')}*`
        }
        options={COUNTRIES.map(({ id, name }) => ({
          label: name,
          value: id
        }))}
      />

      <InputField
        name={getName('line1')}
        label={
          /* TRANSLATORS: Form field for address line 1 */
          `${getText('Address Line 1')}*`
        }
        placeholder={getText('123 5th Street')}
      />

      <InputField
        name={getName('line2')}
        label={
          /* TRANSLATORS: Form field for address line 2 */
          getText('Address Line 2')
        }
        placeholder={getText('e.g., suite 201 (optional)')}
      />

      <InputField
        name={getName('city')}
        label={
          /* TRANSLATORS: Form field for address city */
          `${getText('City')}*`
        }
        placeholder={getText('New York')}
      />

      <Flex flexWrap={['wrap', 'wrap', 'wrap', 'nowrap']}>
        {useUSStateDropdown ? (
          <SelectField
            label={/* TRANSLATORS: US State */ `${getText('State')}*`}
            name="state"
            options={US_STATES.map(state => ({
              label: state.name,
              value: state.id
            }))}
          />
        ) : (
          <Box width={1} pr={[0, 0, 0, '8px']}>
            <InputField
              name={getName('state')}
              label={
                /* TRANSLATORS: Form field for address state/province */
                `${getText('State/Province')}*`
              }
              placeholder={getText('New York')}
            />
          </Box>
        )}

        <Box width={1} pl={[0, 0, 0, '8px']}>
          <InputField
            name={getName('zipcode')}
            label={
              /* TRANSLATORS: Form field for address zip/postal code */
              `${getText('Zip/Postal Code')}*`
            }
            placeholder="10001"
          />
        </Box>
      </Flex>
    </>
  );
};

export default AddressWithoutLocationForm;
